import React from 'react';
import BatteryAlertIcon from '@material-ui/icons/BatteryAlert';
import { BoxStatus } from 'home/useSubBoxStatuses';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Label } from 'labels';

interface Props {
  status: BoxStatus;
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    color: ({ status }: Props) =>
      !status.isOnline ? theme.palette.grey[500] : theme.palette.error.main,
  },
}));

const BatteryIcon = ({ status }: Props) => {
  const classes = useStyles({ status });

  return status.isBattery ? (
    <Tooltip title={Label.BackupBattery + '使用中'}>
      <BatteryAlertIcon className={classes.icon} />
    </Tooltip>
  ) : null;
};

export default BatteryIcon;
